<template>
    <div class="spotlight-widget spotlight-unit-widget spotlight-widget--clickable" @click="copyResult">
        <div class="spotlight-widget-icon spotlight-widget-icon--unit">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
        </div>
        <div class="spotlight-widget-content">
            <div class="spotlight-widget-result">{{ formattedInput }} <span class="spotlight-widget-arrow">→</span> {{ formattedOutput }}</div>
            <div v-if="!isTemp" class="spotlight-widget-expression">1 {{ displayFrom }} = {{ unitRate }} {{ displayTo }}</div>
        </div>
        <div v-if="copied" class="spotlight-widget-copied">{{ $t('common.spotlight.copied') }}</div>
    </div>
</template>

<script>
import { UNITS, convertUnit } from './unitData'

export default {
    name: 'UnitConverter',
    props: {
        query: { type: Object, required: true }
    },
    data() {
        return { copied: false }
    },
    computed: {
        displayFrom() {
            return UNITS[this.query.from]?.display || this.query.from
        },
        displayTo() {
            return UNITS[this.query.to]?.display || this.query.to
        },
        isTemp() {
            return UNITS[this.query.from]?.cat === 'temp'
        },
        convertedAmount() {
            return convertUnit(this.query.amount, this.query.from, this.query.to)
        },
        unitRateValue() {
            return convertUnit(1, this.query.from, this.query.to)
        },
        unitRate() {
            if (this.unitRateValue === null) return ''
            return this.formatNumber(this.unitRateValue)
        },
        formattedInput() {
            return this.formatNumber(this.query.amount) + ' ' + this.displayFrom
        },
        formattedOutput() {
            if (this.convertedAmount === null) return '—'
            return this.formatNumber(this.convertedAmount) + ' ' + this.displayTo
        }
    },
    methods: {
        formatNumber(val) {
            if (val === 0) return '0'
            const abs = Math.abs(val)
            if (Number.isInteger(val) && abs < 1e15) return val.toLocaleString('tr-TR')
            if (abs >= 1) return val.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })
            return val.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 6 })
        },
        async copyResult() {
            if (this.convertedAmount === null) return
            try {
                const raw = Number.isInteger(this.convertedAmount) ? String(this.convertedAmount) : this.convertedAmount.toFixed(4)
                await navigator.clipboard.writeText(raw)
                this.copied = true
                setTimeout(() => { this.copied = false }, 1500)
            } catch (e) { void e }
        }
    }
}
</script>
